import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes'
import { ActionIcon } from '@mantine/core'
import { useMediaQuery } from '@mantine/hooks'
import { clsx } from 'clsx'
import { type HTMLAttributes } from 'react'

import { type UNSAFE_any } from '@flecto/types'
import { Icon } from '@flecto/ui'

import classes from './styles.module.css'

export function PageClose({
  className,
  ...rest
}: HTMLAttributes<HTMLButtonElement>) {
  const closeClasses = clsx(classes.pageClose, className)
  const isMobile = useMediaQuery('(max-width: 500px)')

  const props = isMobile
    ? {
        size: 'sm',
        radius: 'sm',
      }
    : {
        size: 'md',
        radius: 'md',
      }

  return (
    <ActionIcon variant='light' className={closeClasses} {...rest}>
      <Icon icon={faTimes} size={props.size as UNSAFE_any} />
    </ActionIcon>
  )
}

PageClose.displayName = 'PageClose'
